<template>
    <div class="mainpart-vertical">
        <h1 class="h1">
            ##《奕鸣软件许可及服务协议》(以下简称“本协议”)
        </h1>
        <h3 class="h3">
            是由您与奕鸣运营方就使用奕鸣产品和服务所达成的协议。在您开始使用奕鸣产品和服务之前，请您务必审慎阅读本协议及奕鸣运营方公布的《奕鸣隐私政策》，并充分理解各条款内容特别是涉及限制或者免除责任的条款。
        </h3>
        <div class="text">
            <div class="h2">
                ###
                1.协议范围
            </div>
            <div class="text">
                1.1 本协议约定了金华市奕鸣科技有限公司和您之间就使用奕鸣产品和服务事宜发生的权利义务关系。
            </div>
            <div class="text">
                1.2奕鸣运营方:是指金华市奕鸣科技有限公司（注册地址：浙江省金华市义乌市后宅街道群英路111号3楼308），但就本协议涉及、及奕鸣产品将来可能涉及的某些服务项目，奕鸣运营方的关联企业也可能向您提供产品和服务，与您发生权利义务关系。本协议中，关联企业是指控制某一方的、或被某一方所控制的、或与某一方共同受控制于同一实体的任何企业。控制是指直接或间接拥有该企业百分之五十(50%)以上的股权、投票权或管理权
            </div>
            <div class="text">
                1.3用户:又称“您”，是指任何以合法的方式获取和使用奕鸣产品的人，不限于自然人或机构。
            </div>
            <div class="text">
                1.4奕鸣产品:又称奕鸣或奕鸣软件，是指由奕鸣运营方合法拥有并运营的、标注名称为奕鸣的移动客户端应用程序。客户端应用程序以软件形式提供，包括但不限于iOSAndroid等多个版本，您须选择与所安装终端设备相匹配的软件版本。
            </div>
            <div class="text">
                1.5奕鸣服务: 指奕鸣运营方向您提供的与奕鸣产品相关的各项运营服务
            </div>
            <div class="text">
                1.6本协议内容同时包括奕鸣运营方及其关联企业可能不断发布的关于奕鸣产品和服务的业务规则、相关协议及其修订版本等内容。上述内容一经正式发布，即为本协议不可分割的组成部分，您同样应当遵守。
            </div>
            <div class="text">
                1.7奕鸣运营方有权将本服务或本协议项下之权利义务委托给其关联公司或其他第三方公司进行运营、管理及履行，奕鸣运营方无需就此向您另行获取授权(如涉及对您权益的重大变更或减损，奕鸣运营方将另行征求您的同意)。届时，奕鸣运营方将竭尽避免前述委托或变更给奕鸣产品相关的各项服务造成的不便。同时奕鸣运营方向您承诺将依照法律法规的规定采取严格措施保护您在奕鸣的数据的安全。
            </div>
        </div>
        <div class="text">
            <div class="h2">
                ###
                2.产品与服务
            </div>
            <div class="text">
                2.1 请您留意识别安装程序的来源，您应从合法的渠道下载奕鸣产品至其合法拥有的终端设备中。同时，我们提示您：
                <div class="text">
                    2.1.1奕鸣运营方给予您一项个人的、不可转让及非排他性的许可以使用奕鸣产品及服务，您可以非商业目的在终端设备上安装、使用奕鸣产品，奕鸣运营方也保留在任何必要情形下收回该授权的权利。但除非得到特别的授权，否则，您不应也不得以任何形式改编、复制或交易奕鸣产品。
                </div>
                <div class="text">
                    2.1.2如果您从未经奕鸣运营方授权的第三方获取奕鸣产品或与奕鸣产品名称相同的安装程序，奕鸣运营方无法保证该产品能够正常使用，并且，奕鸣运营方不对因此造成的任何损失负责。
                </div>
            </div>
            <div class="text">
                2.2一旦您在您的终端设备中打开并进入奕鸣产品，即视为使用奕鸣产品和服务。为充分实现奕鸣产品及服务的全部功能，您可能需要将终端设备联网。
            </div>
            <div class="text">
                2.3为了保证奕鸣产品和服务的安全性和功能的一致性，奕鸣运营方有权无需向您做特别通知而对软件进行更新，或者对软件的部分功能效果进行改变或限制。
            </div>
            <div class="text">
                2.4奕鸣软件新版本发布后，旧版本的软件可能无法使用。奕鸣运营方不保证旧版本软件继续可用，请您随时核对并下载最新版本。
            </div>
            <div class="text">
                2.5您理解并同意:为了提供有效的服务，奕鸣会利用您终端设备的处理器和带宽等资源。奕鸣使用过程中可能会产生数据流量费用，您需自行向运营商了解相关资费信息，并自行承担相关费用。
            </div>
            <div class="text">
                2.6您在使用本服务的过程中，需要提供一些必要的信息，例如:为向您提供账号注册服务或对您进行身份识别，您需要填写手机号码:部分定位功能需要您同意使用您所在的地理位置信息，拍摄照片需要您同意使用相机和存储权限等。若国家法律法规或政策有特殊规定，需要您提供真实的身份信息的，则若您拒绝提供信息或您提供的信息不完整，则无法使用对应功能或在使用的过程中受到限制。
            </div>
            <div class="text">
                2.7您在使用本软件及服务时，须自行承担如下奕鸣运营方不可掌控的风险内容，包括但不限于：
                <div class="text">
                    2.7.1由于不可抗拒因素可能引起的个人信息丢失、泄漏等风险;
                </div>
                <div class="text">
                    2.7.2您必须选择与所安装终端设备匹配的软件版本否则，由于软件与终端设备型号不相匹配所导致的任何问题或损害，均由您自行承担
                </div>
                <div class="text">
                    2.7.3由于无线网络信号不稳定、无线网络带宽小等原因，所引起的登录失败、资料同步不完整、页面打开速度慢等风险。
                </div>
            </div>
            <div class="text">
                2.8您理解并同意，奕鸣运营方将会尽其商业上的合理努力保障您于本软件及服务中的数据存储安全，但是奕鸣运营方并不能就此完全保证，包括但不限于以下情形:
                <div class="text">
                    2.8.1奕鸣运营方不对您在本软件及服务中相关数据的删除或存储失败负责。
                </div>
                <div class="text">
                    2.8.2奕鸣运营方将依照相关法律法规的规定对您在使用奕鸣服务过程中所产生的数据进行存储保护;
                    如果您停止使用本软件及服务或服务被终止或取消，奕鸣运营方可以在保存期限(如有)届满后从服务器上永久地删除您的数据。服务停止、终止或取消后，奕鸣运营方没有义务向您返还数据。
                </div>
            </div>
        </div>
        <div class="text">
            <div class="h2">
                ###
                3.账号和您的行为
            </div>
            <div class="text">
                3.1奕鸣将为您提供帐号，是您用以登录奕鸣产品、使用奕鸣产品和/或接受奕鸣服务的凭证。奕鸣账号的所有权归属奕鸣运营方。
            </div>
            <div class="text">
                3.2您有责任妥善保管注册账号信息及账号密码，您需要对使用的账号及密码下的行为承担法律责任，包括数据的修改、上传以及其他在奕鸣产品上的操作行为。若发现他人未经许可使用您的账号或您的账号下发生其他任何安全漏洞问题，您可立即通知奕鸣运营方。
            </div>
            <div class="text">
                3.3 您也可选择通过奕鸣的账号关联系统使用您合法拥有的其他账号登录奕鸣产品(具体支持以届时的登录设置为准)。您以上述已有账号进行登录的，对应于奕鸣中生成的账号同样适用本协议中对账号的相关约定。
            </div>
            <div class="text">
                3.4您不得使用未经奕鸣运营方授权或许可的任何插件、“外挂”或第三方工具对奕鸣产品和服务的正常运行进行干扰、破坏、修改或施加其他影响。
            </div>
            <div class="text">
                3.5 您不得利用或针对奕鸣产品实施任何危害计算机网络安全的行为，包括但不限于:
                <div class="text">
                    3.5.1未经许可使用奕鸣的相关数据或在未经许可的情形下进入奕鸣的相关服务器/帐户;
                </div>
                <div class="text">
                    3.5.2未经许可，企图探查、扫描、测试奕鸣产品系统或网络的弱点或实施其它破坏网络安全的行为;
                </div>
                <div class="text">
                    3.5.3企图干涉、破坏奕鸣产品系统或网站的正常运行，故意传播恶意程序或病毒以及其他破坏干扰正常网络信息服务的行为;
                </div>
                <div class="text">
                    3.5.4伪造TCP/IP数据包名称或部分名称。
                </div>
            </div>
        </div>
        <div class="text">
            <div class="h2">
                ###
                4.知识产权
            </div>
            <div class="text">
                4.1奕鸣运营方是奕鸣产品的知识产权权利人。奕鸣的一切著作权、商标权、专利权、商业秘密等知识产权，以及与奕鸣相关的所有信息内容(包括但不限于文字、图片、视频、音频、界面设计、版本框架等)均受中华人民共和国法律法规和相应国际条约的保护，奕鸣运营方享有上述知识产权(相关权利人依照法律规定应当享有的权利除外)。
            </div>
            <div class="text">
                4.2未经相关权利人同意，您不得对奕鸣产品和服务涉及的相关网页、应用、软件等产品进行反向工程、反向汇编、反向编译等;也不得为任何商业或非商业目的自行或许可任何第三方实施、利用、转让上述知识产权。
            </div>
            <div class="text">
                4.3奕鸣产品和服务中所包含内容的知识产权均受到法律保护，未经奕鸣运营方、您或相关权利人书面许可，任何人不得以任何形式进行使用或创造相关衍生作品。
            </div>
        </div>
        <div class="text">
            <div class="h2">
                ###
                5.个人信息和隐私保护
            </div>
            <div class="text">
                5.1 保护您的个人信息是奕鸣运营方的一项基本原则奕鸣运营方将按照本协议及奕鸣运营方公布的《隐私政策》的规定收集、使用、存储和分享您的个人信息。
            </div>
            <div class="text">
                5.2维护软件的安全与正常使用是奕鸣运营方与您的共同责任，奕鸣运营方将按照行业标准审慎采取必要措施保护您的设备信息和数据安全，但是同时，您应了解并认可奕鸣运营方无法就此向您提供完全的保证。在我们与您共同维护您的个人信息安全的同时，您也应该尊重他人的合法权益且不应以任何方式侵害他人，如您不应也不得制作、发布、使用、传播任何用于窃取他人账号及他人个人信息、财产的恶意程序。
            </div>
            <div class="text">
                5.3
                您理解并同意，奕鸣同大多数互联网软件一样，可能会受到多种因素的影响，包括但不限于您及/或其他用户的原因、网络服务质量、社会环境等;也可能被他人非法利用信息资料等各种安全问题侵扰;您下载安装的其他软件或访问的其他网站中可能含有病毒、木马程序或其他恶意程序，威胁您的终端设备信息和数据安全等。因此，您应加强信息安全及个人信息的保护意识注意识别信息的来源，注意个人信息及帐户密码的保护，以免遭受损失。在此，我们特别提示您，在任何情况下，您都不应轻信借款、索要密码或任何其他涉及财产及个人身份信息的网络信息。涉及个人信息提供及财产操作的，请先核实对方身份，奕鸣不对也无法对相关向您索要信息的主体进行核实也不会对因此产生的损失承担责任。
            </div>
            <div class="text">
                5.4奕鸣运营方将运用各种安全技术和程序建立完善的管理制度来保护您的个人信息，以避免其遭受未经授权的访问、使用或披露。
            </div>
            <div class="text">
                5.5奕鸣运营方不会将您的个人信息转移或披露给任何非关联的第三方，除非：
            </div>
            <div class="text">
                5.5.1获得您的明确同意或基于您的主动选择，或
            </div>
            <div class="text">
                5.5.2基于法律法规规定的披露: 在法律、法律程序、诉讼或政府主管部门的强制性要求下进行。
            </div>
            <div class="text">
                5.6 根据规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。
            </div>
            <div class="text">
                5.7在以下情况中奕鸣运营方可能会使用你的个人信息：
                <div class="text">
                    5.7.1奕鸣运营方可能会与第三方合作向您提供相关的网络服务，在此情况下，奕鸣运营方将要求该第三方承担与奕鸣运营方同等的隐私保护责任;
                </div>
                <div class="text">
                    5.7.2在进过去标识化处理无法识别个人信息主题的前提下，奕鸣运营方可能会基于产品提升等需要对整个您数据库进行分析并对您数据库进行商业上的利用。
                </div>
            </div>
        </div>
        <div>
            <div class="h2">
                ###
                6.服务的变更、中断和终止
            </div>
            <div class="text">
                6.1您理解并同意，奕鸣运营方提供的奕鸣产品和服务是按照现有技术和条件所能达到的现状提供的。奕鸣运营方会尽最大努力向您提供更好的服务，确保服务的连贯性和安全性:但奕鸣运营方不能随时预见和防范技术以及其他风险，包括但不限于不可抗力、病毒、木马.黑客攻击、系统不稳定、网络环境、第三方服务瑕疵等原因可能导致的服务中断、数据丢失以及其他损失和风险。对于上述原因造成的数据损失，奕鸣运营方无须向您或第三方负责或承担任何赔偿责任。如发生该等情形，奕鸣运营方将尽可能快速的通过网页公告、系统通知、私信、短信提醒或其他合理方式向受影响的您发送通知。
            </div>
            <div class="text">
                6.2您理解并同意，奕鸣运营方为了服务整体运营的需要，有权在不事先通知您的情况下修改、中断、中止或终止奕鸣产品内的各项服务，而无须向您或第三方负责或承担任何赔偿责任。奕鸣运营方也将尽可能事先向受影响的您发出通知并竭尽保障您的个人数据信息安全完整。
            </div>
        </div>
        <div>
            <div class="h2">
                ###
                7.法律责任声明
            </div>
            <div class="text">
                7.1因客观情况及技术所限，请您理解:奕鸣运营方将尽可能提升服务能力以向您提供更好的服务，如产品中出现任何程序错误，奕鸣运营方也将在发现相关程序错误的第一时间进行更正，但奕鸣运营方无法向您保证产品和服务完全适合您的使用要求，无法向您保证产品或服务不受干扰或不出现任何程序错误。
            </div>
            <div class="text">
                7.2对违反有关法律法规或本协议规定的行为，奕鸣运营方将依法律规定及上述规则加以合理判断进行处理对违法违规的人士采取适当的法律行动，并依据法律法规保存有关信息、向有关部门报告。
            </div>
            <div class="text">
                7.3奕鸣产品中可能包含由您上传的或奕鸣运营方以合法方式获取的外部网络内容或服务链接，您可以通过在奕鸣中获取的链接跳转到外部网页并在对应外部页面获取相关内容和服务。外部网页所涉及的服务可能需要您同时接受该服务特别制订的服务协议或其他约束您与该项服务提供者之间的法律文件。同时，关于您在这些外部服务中所产生的权利和义务，除非另有约定，奕鸣运营方无需向您或第三方的服务内容与效果承担任何责任。
            </div>
        </div>
        <div>
            <div class="h2">
                ###
                8.违约处理
            </div>
            <div class="text">
                8.1因您违反国家法律法规或本协议的约定，或您侵害他人权利而导致任何第三人向奕鸣运营方提出索赔或请求(包括但不限于诉讼费用、律师费用、差旅费用和解金额、罚款或生效法律文书中规定的损害赔偿金额、软件使用费等)而给奕鸣运营方造成损失的，您应赔偿奕鸣运营方因此而遭受的损失，并相关消除影响。
            </div>
            <div class="text">
                8.2如果奕鸣运营方发现或收到他人举报或投诉您发布的相关内容违反法律法规或本协议约定的，奕鸣运营方有权对相关内容进行删除、屏蔽，并可视行为情节对违规账号处以包括警告、限制或禁止使用部分或全部功能、账号封禁直至注销的处罚，并有权公告处理结果。
            </div>
            <div class="text">
                8.3您理解并同意，一有权依合理判断对违反有关法律法规或本协议约定的行为进行处罚，对违法违规的您采取适当的法律行为，并依据法律法规保存有关信息向有关部门报告，愈应自行承担由此而产生的后果及责任。
            </div>
        </div>
        <div>
            <div class="h2">
                ###
                9,其他条款
            </div>
            <div class="text">
                9.1
                本协议可能国国家政策、产品以及属行环境发生变化而进行修改，一键运营方有权在必要时变更本协议条款，并在奕鸣产品的相关页面公布最新版本的协议条款供您查阅。一据运营方也可以选择其他适当的方式向您通知修改的内容，如在相关同站、灭面或应用程序内进行通知，本协议条款变更后，如果您不接受变更后的协欢，您应当停止使用一群产品和服务。如对更新的内容有野问您同样可以通过本协设公布的联系方式联络我们，我们将尽快向您解答。
            </div>
            <div class="text">
                9.2
                本协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律。本协议之任何规定无论因任何原因部分无效或不可执行，则这些条款将以尽可能接近本协议原条文意旨重新解析。且本协议其它规定仍应具有完整的效力及效果。
            </div>
            <div class="text">
                9.3 为免歧义，特在此说明，本协议所有条款的标飘仅为阅读方便，本身并无实际涵文，不应作为本协议涵义解释的依据。
            </div>
        </div>
        <div class="text">
            如果您有任何疑问、意见或建议，通过以下方式与我们联系：
            邮箱：【JinHuaYiMing@163.com】
        </div>
    </div>
</template>
<style scoped>
.mainpart-vertical {
    display: flex;
    flex-direction: column;
    width: 100%;
    height:100vh;
    overflow-y: scroll;
}
.h1 {
    text-align: left;
    margin-left: 16px;
    margin-right: 16px;
    font-size: 46px;
}

.h2 {
    text-align: left;
    margin-left: 16px;
    margin-right: 16px;
    font-size: 24px;
}

.h3 {
    text-align: left;
    margin-left: 16px;
    margin-right: 16px;
    font-size: 18px;
}

.text {
    text-align: left;
    margin-left: 16px;
    margin-right: 16px;
    font-size: 14px;
}
</style>